var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Row, Col } from "react-bootstrap";
import React, { Component } from "react";
import id from "@irati/utils/id";
import { Banner } from "@irati/ui/src/Layout";
import Form from "@irati/ui/src/Form";
import Input from "@irati/ui/src/FormItem/Input";
import ValidationButton from "@irati/ui/src/FormItem/ValidationButton";
import Loading from "@irati/ui/src/Loading";
import Validation from "@irati/utils/validation";
import { injectIntl, FormattedMessage } from "@irati/utils/lang";
import session from "@irati/auth/services/session";
import { hangPromise } from "@irati/utils/promise";
import { RouterLink } from "@irati/ui/src/Link";
import Flex from "@irati/ui/src/Flex";
import HintText from "@irati/ui/src/HintText";
import { getGlobalTenant } from "@irati/region/services/globalTenant";
import { H1, H3, Label } from "@irati/ui/src/Typography";
import LoginBlock from "../../../components/LoginBlock";
import StyledCard from "./styled/LoginCard";
import { InputHolder } from "./styled/Subdomain";
var GlobalLogin = /** @class */ (function (_super) {
    __extends(GlobalLogin, _super);
    function GlobalLogin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            subdomain: localStorage.getItem("companyDomain") || "",
            submit: null
        };
        _this.handleSubmit = function () {
            var subdomain = _this.state.subdomain;
            var submit = getGlobalTenant(subdomain).then(function () {
                localStorage.setItem("companyDomain", subdomain);
                return session.postCrossDomain(subdomain).then(hangPromise);
            });
            _this.setState({ submit: submit });
        };
        _this.updateSubdomain = function (subdomain) {
            _this.setState({ subdomain: subdomain, submit: null });
        };
        return _this;
    }
    GlobalLogin.prototype.render = function () {
        var _this = this;
        var submit = this.state.submit;
        var formatMessage = this.props.formatMessage;
        var idNamespace = id("global-login", this.props);
        return (React.createElement(React.Fragment, null,
            React.createElement(Banner, { id: id("banner", idNamespace) }),
            React.createElement(Row, null,
                React.createElement(Col, { xs: 12 },
                    React.createElement(H1, { id: id("title", idNamespace), color: "white", textAlign: "center", paddingTop: 4 },
                        React.createElement(FormattedMessage, { id: "platform.globalLogin.fields.welcomeTo.header" })))),
            React.createElement(LoginBlock, { size: "small" },
                React.createElement(StyledCard, null,
                    React.createElement("div", { className: "globalLogin_wrapper" },
                        React.createElement(H3, { id: id("card-title", idNamespace), paddingBottom: 3 },
                            React.createElement(FormattedMessage, { id: "platform.globalLogin.fields.signIn.subdomainHeader" })),
                        React.createElement(Form, { form: "global-login" },
                            React.createElement(Flex, { justifyContent: "space-between", alignItems: "center" },
                                React.createElement(InputHolder, null,
                                    React.createElement(Input, { id: id("subdomain", idNamespace), flush: true, label: formatMessage({ id: "platform.globalLogin.fields.subdomain.label" }), name: "subdomain", type: "text", value: this.state.subdomain, placeholder: formatMessage({ id: "platform.globalLogin.fields.subdomain.placeholder" }), onChange: this.updateSubdomain, onEnter: function () {
                                            return Validation.validate()
                                                .then(_this.handleSubmit)
                                                .catch(function () { });
                                        }, validation: Validation.string("platform.globallogin.domain.errors.isrequired"), hideLabel: true, autoFocus: true })),
                                React.createElement(Flex, { marginLeft: true },
                                    React.createElement(Label, null, ".perkbox.com"))),
                            React.createElement(HintText, null,
                                React.createElement(FormattedMessage, { id: "platform.globalLogin.fields.subdomain.hint" })),
                            React.createElement(Loading, { id: id("submit-response", idNamespace), load: submit, useLoader: false }),
                            React.createElement(ValidationButton, { id: id("btn-submit", idNamespace), primary: true, large: true, full: true, marginTop: 6, load: submit, onClick: this.handleSubmit },
                                React.createElement(FormattedMessage, { id: "platform.globalLogin.fields.button.continue" }))),
                        React.createElement(Label, { display: "block", marginTop: 3 },
                            React.createElement(FormattedMessage, { id: "platform.globalLogin.subdomain.help.body", values: {
                                    link: (React.createElement(RouterLink, { cta: true, to: "/welcome/login/domain" },
                                        React.createElement(FormattedMessage, { id: "platform.globalLogin.subdomain.help.link.text" })))
                                } })))))));
    };
    return GlobalLogin;
}(Component));
export default injectIntl(GlobalLogin);
